/**
 * @file     unifiedLeadFlow.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for the unified lead flow chooser screen (buy, sell, find tenants path selection).
 */
export const unifiedLeadFlow = {
  chooser: {
    title: '',
    description:
      'The next questions are tailored to buying, selling, or finding tenants.',
    buyer: 'Buy',
    buyerDescription:
      'Share your budget, property type, and timing.',
    seller: 'Sell',
    sellerDescription:
      'Get an online estimate of your home\'s value and next steps.',
    landlord: 'Find tenants',
    landlordDescription:
      'Get help finding tenants for your rental.',
    resumeDescription: 'Pick up where you left off, or choose a different journey.'
  },
  branch: {
    buyer: 'Property Match',
    buyerDescription:
      'Tell me what you want, what matters, and how soon you want to move.',
    seller: 'Value Pulse',
    sellerDescription:
      'Tell me about your home, your timing, and what you are hoping to achieve.',
    landlord: 'Find Tenants',
    landlordDescription:
      'Tell me about your property and what kind of tenant you are looking for.',
    eyebrow: 'Current journey',
    separator: ' · ',
    switchJourney: 'Pick again'
  }
} as const;
